import Icon from "hardcover-ui/components/Icon";
import faFlag from "icons/solid/flag.svg";
import BlockButton from "components/users/BlockButton";
import ReportButton from "components/ReportDropdown/Report/ReportButton";
import { UserSerializersUserByline } from "types/serializers";
import useCurrentUserId from "hooks/user/useCurrentUserId";

export default function BlockUserButton({ user }: { user: UserSerializersUserByline }) {
  const currentUserId = useCurrentUserId();

  if (!currentUserId || (currentUserId && currentUserId == user.id)) {
    return <></>;
  }

  return (
    <>
      <ReportButton
        objectId={user.id}
        objectType="User"
        description={`User: @${user.username}`}
        close={close}
        variant="ghost"
      >
        <span className="sr-only">Report this user</span>
        <Icon icon={faFlag} size="sm" className="fill-gray-300" />
      </ReportButton>

      <BlockButton userId={user.id} />
    </>
  );
}
